define([
	"dojo/_base/declare",
	"csi/table/Copy"
], function(declare,Copy) {

	return declare(Copy, {
		constructor: function(/*Object*/params) {
			// summary: if copying spanner, then also store in different relation
			var nodeType = this.getNode().$Type;
			if (nodeType != "Order" && nodeType != "CustomerOrder") {
				this.idOwnerRelation = "Spanners";
			}
		},
		
		_toWriterParent: function() {
			var urlParent = this.m_urlParent;
			var parent = this.getParent();
			
			if (!this.idOwnerRelation && (parent.$Type != "PurchasedOrder")) {
				this.m_urlParent = parent.PO;
			}
			
			this.inherited(arguments);
			this.m_urlParent = urlParent;
		}
	});
});